export const APP_ROUTES = {
  HOME: '/',
  SETTINGS: '/settings',
  PROFILE: '/profile',
  SIGN_IN: '/sign-in',
  USERS: '/users',
  MESSAGES: '/messages',
  POSTS: '/posts',
  BOTS: '/bots',
};